var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "po-content", attrs: { "data-testid": "po-row" } },
    [
      _c(
        "div",
        {
          staticClass: "content__frame po__page mb-8",
          attrs: { id: "div-content" }
        },
        [
          _c("div", { staticClass: "row m-0" }, [
            _c(
              "div",
              { staticClass: "col-3 col-lg-3 pr-16 align-self-center" },
              [
                _c("div", { staticClass: "d-flex row m-0" }, [
                  _c(
                    "div",
                    { staticClass: "form__rowNum ordinal-no col-1 p-0" },
                    [_vm._v(_vm._s(_vm.index + 1) + ".")]
                  ),
                  _c(
                    "div",
                    {
                      staticClass:
                        "col-11 d-flex flex-column w-100 pl-sm-3 pr-0"
                    },
                    [
                      _c("EpInput", {
                        staticClass: "form__control",
                        class: { "error-controls": _vm.poItem.error },
                        attrs: {
                          "aria-label": "Po number",
                          type: "text",
                          placeholder: _vm.getTextByCountry(
                            _vm.countryCode,
                            "component_epPOPaymentRow_poInput_placeholder"
                          ),
                          value: _vm.poItem.poNumber,
                          maxlength: 12
                        },
                        on: {
                          blur: _vm.handlePoNumberInputBlur,
                          input: _vm.handlePoNumberChange
                        }
                      })
                    ],
                    1
                  )
                ])
              ]
            ),
            _c(
              "div",
              { staticClass: "col-3 col-lg-2 pl-16 align-self-center" },
              [
                _c("div", { staticClass: "row m-0" }, [
                  _c(
                    "div",
                    { staticClass: "col-6 col-lg-6 p-0 m-0" },
                    [
                      _c(
                        "EpLabel",
                        {
                          staticClass: "label-display",
                          attrs: { "data-testid": "records-label" }
                        },
                        [_vm._v(_vm._s(_vm.poItem.records || "- - -"))]
                      )
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "col-6 col-lg-6" },
                    [
                      _c(
                        "EpLabel",
                        {
                          staticClass: "form__txtCurrency label-display",
                          attrs: { "data-testid": "currency-label" }
                        },
                        [_vm._v(_vm._s(_vm.poItem.currency))]
                      )
                    ],
                    1
                  )
                ])
              ]
            ),
            _c("div", { staticClass: "col-6 col-lg-7 align-self-center" }, [
              _c("div", { staticClass: "row" }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "col-4 col-lg-3 text-right pr-24 align-self-center"
                  },
                  [
                    _vm.poItem.amount
                      ? _c(
                          "EpLabel",
                          {
                            staticClass: "amount-text label-display",
                            attrs: { "data-testid": "amount-label" }
                          },
                          [_vm._v(" " + _vm._s(_vm.poItem.amount) + " ")]
                        )
                      : _c(
                          "span",
                          { attrs: { "data-testid": "amount-label" } },
                          [_vm._v(" - - - ")]
                        )
                  ],
                  1
                ),
                _c("div", { staticClass: "col-8 col-lg-9 pl-24 pr-0" }, [
                  _c("div", { staticClass: "row m-0" }, [
                    _c(
                      "div",
                      { staticClass: "col-8 col-lg-10 p-0 align-self-center" },
                      [
                        _c(
                          "EpLabel",
                          {
                            staticClass: "label-display txt-break-word",
                            attrs: { "data-testid": "company-name-label" }
                          },
                          [_vm._v(_vm._s(_vm.poItem.companyName || "- - -"))]
                        )
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-4 col-lg-2 pr-0 align-self-center" },
                      [
                        _c(
                          "div",
                          { staticClass: "d-flex form__delete float-right" },
                          [
                            _c(
                              "EpIconButton",
                              {
                                staticClass: "p-sm-0 bd-t-none",
                                attrs: { "data-testid": "remove-button" },
                                on: { click: _vm.handleRemoveButtonClick }
                              },
                              [_c("DeleteIcon")],
                              1
                            )
                          ],
                          1
                        )
                      ]
                    )
                  ])
                ])
              ])
            ])
          ]),
          _vm.poItem.error
            ? _c("div", { staticClass: "row m-0" }, [
                _c("div", { staticClass: "col-12 col-lg-3" }, [
                  _c("div", { staticClass: "d-flex row m-0" }, [
                    _c("div", {
                      staticClass:
                        "form__rowNum ordinal-no col-1 p-0 rowNum__custom"
                    }),
                    _c(
                      "div",
                      {
                        staticClass:
                          "d-flex flex-column w-100 pr-2 pl-sm-3 col-11 content__feedback font-16",
                        attrs: { "data-testid": "error-message" }
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.poItem.error ? _vm.poItem.error.message : ""
                            ) +
                            " "
                        )
                      ]
                    )
                  ])
                ])
              ])
            : _vm._e()
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }